import { useLocation } from "react-router";
import { Table } from "../../features/Table";
import {
  type ForeignExchangeRate,
  getForeignExchangeRateColumns,
} from "./columns";
import { FilterForeignExchangeRate } from "./filter";
import { useTranslation } from "react-i18next";

const client = "etl-quantilia";
const table_name = "foreign_exchange_rates";

export const ForeignExchangeRatesTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;
  const { t } = useTranslation();
  const columns = getForeignExchangeRateColumns(t);

  return (
    <Table<ForeignExchangeRate, ForeignExchangeRate>
      label={t("foreign_exchange_rate.title")}
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<FilterForeignExchangeRate />}
      disable_translations_request={true}
      actions={[
        {
          label: t("actions.new"),
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
